import paola from "../assets/images/paolaquadretti.jpg"
import atelier from "../assets/images/atelier.jpeg"


export function AboutUsPage() {
    return (
        <>
        <div className="container-fluid g-0">
            <div className="row g-0">
                <div className="col-12 py-3 px-4 bb">
                    <h3>About us</h3>
                </div>
            </div>
        </div>
        <div className="container mt-5">
            <div className="row">
                <div className="col-12 col-md-6 my-4">
                    <img className="img-fluid" src={paola} />
                </div>
                <div className="col-12 col-md-6 my-4">
                    <h2>PAOLA QUADRETTI</h2>
                    <h5>Identity in a dress</h5>
                    <p>Charisma is Paola Quadretti’s signature—both in her character and in her creations. Every garment is an expression of herself and embodies her grace, her elegance, and her charm. Her collections of haute couture are born from sartorial artisanship, opulent details, and fabrics that hail from the most exclusive Italian and French producers.</p>
                </div>

                <div className="col-12 col-md-6 my-4">
                    <h2>Our Atelier</h2>
                    <p>Our atelier is located in Palazzo Capponi delle Rovinate, built around 1426. The Palazzo's late-Gothic 15th-century façade leads you into a world of artistic inspiration, making it the perfect location for our haute couture brand. A few steps away from the Ponte Vecchio, the core of Florentine artisanal production, we are able to give life to unique creations. While staying true to the evergreen concepts of haute couture, our designs are in constant evolution. Enriched by an attention to detail that is characteristic of our custom made garments, we are able to make every piece feel personal: a true expression of oneself.</p>
                </div>
                <div className="col-12 col-md-6 my-4">
                    <img className="img-fluid" src={atelier} />
                </div>
            </div>
        </div>
        </>
    )
}